// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"bba443c3","697":"aacb345e"}[chunkId] + ".chunk.js";
};